<template>
  <div>
    <mobile-control v-if="isMobile"></mobile-control>
    <pc-control v-if="!isMobile"></pc-control>
  </div>
</template>
<script>
import MobileControl from './examsence/mobile'
import PcControl from './examsence/pc'
export default {
  components:{
    MobileControl,PcControl
  },
  data() {
    return {
      isMobile: false
    }
  },
  computed: {
    device() {
      return this.$store.state.app.device
    }
  },
  created() {
    this.isMobile = this.device
  },
  watch:{
    device(val){
      this.isMobile = val
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/home/examsence.vue